/**
 * Route for `cap-limits-campaign-publisher-geo-landing-page-levels`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CapLimitsCampaignPublisherGeoLandingPageLevelsPage } from "../features/cap-limits-campaign-publisher-geo-landing-page-levels/CapLimitsCampaignPublisherGeoLandingPageLevelsPage";

export const capLimitsCampaignPublisherGeoLandingPageLevelsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/cap-limits-campaign-publisher-geo-landing-page-levels",
	component: CapLimitsCampaignPublisherGeoLandingPageLevelsPage,
});

export default capLimitsCampaignPublisherGeoLandingPageLevelsRoute;
